import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { type RequestFailedAction } from '../../../admin-types';
import { send, sendRaw } from '../send-request';
import {
  authLogLoad,
  changePassword,
  login,
  loginResponse,
  logout,
  profileLoad,
  sessionRevoke,
  sessionsLoad,
  sessionsRevokeOthers,
  usernameChange,
} from './reducer';

export default class User {
  static *login(
    socket: Socket,
    action: ReturnType<typeof login>,
  ): Generator<
    CallEffect | PutEffect,
    void,
    ReturnType<typeof loginResponse> | RequestFailedAction
  > {
    const response: ReturnType<typeof loginResponse> | RequestFailedAction =
      yield call(sendRaw, socket, action);

    yield put(response);
  }

  static *logout(
    socket: Socket,
    action: ReturnType<typeof logout>,
  ): Generator<CallEffect, void, void> {
    yield call(sendRaw, socket, action);

    window.location.assign('/login');
  }
}

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(login.type, User.login, socket);
  yield takeEvery(logout.type, User.logout, socket);
  yield takeEvery(changePassword.type, send, socket);
  yield takeEvery(usernameChange.type, send, socket);
  yield takeEvery(profileLoad.type, send, socket);
  yield takeEvery(authLogLoad.type, send, socket);
  yield takeEvery(sessionsLoad.type, send, socket);
  yield takeEvery(sessionRevoke.type, send, socket);
  yield takeEvery(sessionsRevokeOthers.type, send, socket);
}
